<template>
  <div id="scholar">
    <TopList :navList="navList" @setType="setType"></TopList>
    <UserInfo
      v-if="type === 0"
      ref="UserInfo"
    ></UserInfo>
    <Personage v-if="type === 1"></Personage>
    <Scholarship :sysUserPrize="sysUserPrize" v-if="type === 2"></Scholarship>
  </div>
</template>

<script>
import TopList from "../../components/topList";
import Scholarship from "./components/scholarship";
import UserInfo from "./components/userInfo";
import Personage from "./components/personage";
import { mapState } from "vuex";

export default {
  name: "index",
  components: {
    TopList,
    Scholarship,
    UserInfo,
    Personage,
  },
  created() {
    this.getUserDetails();
    if (
      this.userInfo.user.customerType === 1 ||
      this.userInfo.user.customerType === 2 ||
      this.userInfo.user.customerType === 3
    ) {
      this.navList = ["基本信息", "个人履历", "获奖情况"];
      this.user = "xuezhe";
    } else if (this.userInfo.user.customerType === 4) {
      this.navList = ["账号设置", "期刊信息", "子账号设置"];
      this.user = "qikan";
    } else {
      this.navList = [""];
      this.user = "jigou";
    }
  },
  data() {
    return {
      user: "xuezhe",
      navList: [
        "基本信息",
        "个人履历",
        // "获奖情况"
      ],
      type: 0,
      sysUserPrize: {},
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  methods: {
    setType(e) {
      this.type = e;
    },
    async getUserDetails() {
      let res = await this.$apis.userServe.userDetails();
      this.sysUserPrize = res.content.detail.sysUserPrize;
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
